import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EsteticaModal from './EsteticaModal';

// Fondo fijo con imagen optimizada - Componente compartido
const FixedBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden">
    <div 
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-crema/90 via-crema/95 to-crema/20"></div>
    </div>
    
    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-b from-green-50/20 to-transparent hidden md:block"></div>
    <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-t from-teal-50/20 to-transparent hidden md:block"></div>

    <div className="absolute inset-0 opacity-3 md:opacity-5 mix-blend-overlay">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <pattern 
          id="pattern" 
          x="0" 
          y="0" 
          width="60" 
          height="60" 
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(15)"
        >
          <circle cx="30" cy="30" r="1" fill="#869370" opacity="0.4" />
          <circle cx="45" cy="45" r="0.8" fill="#6a7556" opacity="0.3" />
        </pattern>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern)" />
      </svg>
    </div>
    
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxmaWx0ZXIgaWQ9Im5vaXNlIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iMC43IiBudW1PY3RhdmVzPSIzIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNub2lzZSkiIGOPY2l0eT0iMC4wMiIvPjwvc3ZnPg==')] 
      mix-blend-overlay pointer-events-none opacity-50 md:opacity-100"></div>
  </div>
);

// Iconos modernizados
const DurationIcon = () => (
  <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);

const DressCodeIcon = () => (
  <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
  </svg>
);

// Imágenes para masajes
const treatmentImages = {
  espalda: 'https://www.clinicaphysis.com/wp-content/uploads/2022/10/masaje-descontracturante-valencia.png',
  completo: 'https://ecopostural.com/wp-content/uploads/2024/03/tipos_de_masaje_relajante_Ecopostural.jpg',
  piedras: 'https://esteticasecretos.com/wp-content/uploads/2020/11/piedras-volcanicas.jpeg',
  piedrasadd: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9kX-v8doV-LYcJH3KWS47feSOVlXc-GaoJw&s',
  relajante: 'https://images.unsplash.com/photo-1571019614243-cf9a0b47a5cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  craneofacial: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  podal: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  plus: 'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80'
};

function EsteticaMasajes() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ 
    title: '', 
    description: '', 
    imageUrl: '', 
    duration: '', 
    dressCode: '', 
    benefits: [] 
  });

  const openModal = (title, description, imageKey, duration, dressCode, benefits) => {
    setModalContent({ 
      title: title || 'Tratamiento', 
      description: description || 'Descripción del tratamiento', 
      imageUrl: treatmentImages[imageKey] || treatmentImages.relajante || 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
      duration: duration || 'Consultar', 
      dressCode: dressCode || 'Ropa cómoda', 
      benefits: benefits || ['Beneficios del tratamiento'] 
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const tratamientosMasajes = [
    {
      category: "MASAJES",
      subtitle: "Bienestar en cada toque",
      isPlus: false,
      items: [
        { 
          name: "Masaje relajante o descontracturante espalda", 
          price: "80.000 Gs", 
          subtitle: "30 minutos",
          description: "Sesión enfocada en la zona dorsal y lumbar para disolver nudos musculares y aliviar tensiones provocadas por el estrés cotidiano.", 
          imageKey: "espalda", 
          duration: "30 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Alivia sobrecarga muscular", "Descontractura la espalda", "Sensación de alivio rápido"] 
        },
        { 
          name: "1 hora de masajes en espalda, cuello y brazos", 
          price: "150.000 Gs", 
          subtitle: "60 minutos",
          description: "Tratamiento de alta profundidad abarcando todo el tren superior para liberar rigidez muscular en cuello, hombros, espalda y brazos.", 
          imageKey: "espalda", 
          duration: "60 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Alivio profundo del tren superior", "Descongestiona contracturas del cuello", "Mejora la flexibilidad de hombros"] 
        },
        { 
          name: "40 minutos de masajes en cuello, brazos y espalda", 
          price: "120.000 Gs", 
          subtitle: "40 minutos",
          description: "Terapia intermedia ideal para renovar energías y aliviar tensiones acumuladas en la zona cervical y extremidades superiores.", 
          imageKey: "espalda", 
          duration: "40 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Disminuye el estrés acumulado", "Relaja la zona cervical", "Estimula la circulación"] 
        },
        { 
          name: "Masaje craneofacial", 
          price: "60.000 Gs", 
          subtitle: "20 a 25 minutos con aromaterapia",
          description: "Técnica suave en cabeza, rostro y cuello combinada con aromaterapia para combatir migrañas, cansancio mental y tensión ocular.", 
          imageKey: "craneofacial", 
          duration: "20 a 25 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Alivia dolores de cabeza y tensión", "Induce un descanso profundo", "Experiencia de aromaterapia"] 
        },
        { 
          name: "1 hora de masajes cuerpo completo", 
          price: "180.000 Gs", 
          subtitle: "60 minutos",
          description: "Masaje integral descontracturante de pies a cabeza para renovar tu estado físico y emocional de forma armónica.", 
          imageKey: "completo", 
          duration: "60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Relajación corporal total", "Equilibra el sistema nervioso", "Alivia pesadez muscular"] 
        },
        { 
          name: "Piedras volcánicas (adicional)", 
          price: "20.000 Gs",
          subtitle: "Adicional para cualquier masaje",
          description: "Complemento de piedras basálticas calientes aplicadas estratégicamente para calentar la musculatura y profundizar el descanso.", 
          imageKey: "piedrasadd", 
          duration: "Durante la sesión", 
          dressCode: "N/A", 
          benefits: ["Termoterapia profunda", "Potencia el efecto descontracturante", "Sensación cálida y reconfortante"] 
        },
      ],
    },
    {
      category: "Masaje Plus",
      subtitle: "Experiencia multisensorial de renovación profunda",
      isPlus: true,
      items: [
        { 
          name: "Masaje Plus Completo", 
          price: "220.000 Gs", 
          subtitle: "1 hora de sesión completa",
          description: "1 hora de masajes relajantes y descontracturantes con aceites esenciales, aromaterapia, musicoterapia, piedras volcánicas y meditación con cuenco tibetano.", 
          imageKey: "plus", 
          duration: "60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: [
            "Combinación única de terapia física y sonora",
            "Relajación profunda con cuenco tibetano",
            "Piedras volcánicas y aceites botánicos",
            "Desconexión total de la rutina"
          ] 
        },
        { 
          name: "Masaje podal (masaje en pies)", 
          price: "75.000 Gs", 
          subtitle: "Reflexología y descanso pedial",
          description: "Masaje localizado en pies y tobillos activando puntos reflejos para aliviar el cansancio y mejorar el retorno venoso.", 
          imageKey: "podal", 
          duration: "30 a 40 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Deshincha pies cansados", "Estimula puntos de reflexología", "Aporta sensación de ligereza"] 
        },
      ],
    }
  ];

  return (
    <div className="relative">
      <div className="relative z-10">
        <FixedBackground />
        <motion.section 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="min-h-screen relative overflow-hidden py-20 pt-32"
        >
          <div className="container mx-auto px-4 relative z-10">
            {/* Header oficial */}
            <motion.div
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center mb-16"
            >
              <div className="inline-block px-4 py-1.5 rounded-full bg-teal-100/80 text-teal-800 text-sm font-semibold mb-3 shadow-sm border border-teal-200">
                Un momento para vos... ♡
              </div>
              
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-semibold text-green-700 mb-4 font-serif">
                Masajes Relajantes y Descontracturantes
              </h2>
              
              <p className="text-base md:text-xl text-teal-900 font-medium max-w-3xl mx-auto mb-3">
                Un espacio para liberar tensiones, relajar el cuerpo y desconectarte de la rutina.
              </p>

              <p className="text-sm md:text-base text-gray-700 max-w-3xl mx-auto leading-relaxed font-light">
                Combinamos el masaje con una experiencia sensorial que puede incluir aromaterapia, musicoterapia, cuencos tibetanos, Reiki y técnicas de relajación y armonización energética, creando un momento pensado para renovar cuerpo y mente.
              </p>

              <div className="mt-6 flex justify-center">
                <div className="w-28 h-1 bg-gradient-to-r from-teal-400 via-green-400 to-emerald-400 rounded-full"></div>
              </div>
            </motion.div>

            {/* Categorías de masajes */}
            <div className="space-y-16">
              {tratamientosMasajes.map((categoryData, catIdx) => (
                <div key={catIdx} className="space-y-8">
                  {/* Encabezado Banner */}
                  <div className={`p-6 rounded-2xl shadow-sm backdrop-blur-md border ${
                    categoryData.isPlus 
                      ? 'bg-gradient-to-r from-teal-900/90 to-emerald-800/90 text-white border-teal-700/50' 
                      : 'bg-white/70 text-gray-800 border-teal-200/60'
                  }`}>
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                      <div className="flex items-center space-x-3">
                        <span className={`p-2.5 rounded-xl ${categoryData.isPlus ? 'bg-white/20 text-teal-200' : 'bg-teal-100 text-teal-700'}`}>
                          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </span>
                        <div>
                          <h3 className={`text-2xl md:text-3xl font-bold font-serif ${categoryData.isPlus ? 'text-white' : 'text-teal-900'}`}>
                            {categoryData.category}
                          </h3>
                          <p className={`text-sm ${categoryData.isPlus ? 'text-teal-100' : 'text-gray-600'}`}>
                            {categoryData.subtitle}
                          </p>
                        </div>
                      </div>
                      {categoryData.isPlus && (
                        <span className="self-start md:self-auto bg-amber-400 text-gray-900 text-xs font-bold uppercase px-3 py-1 rounded-full shadow-sm">
                          Experiencia Premium
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Grid de servicios */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {categoryData.items.map((item, itemIndex) => (
                      <motion.div
                        key={itemIndex}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: itemIndex * 0.05, duration: 0.4 }}
                        whileHover={{ y: -6, transition: { duration: 0.2 } }}
                        className="bg-white/60 backdrop-blur-md rounded-2xl shadow-md border border-white/60 overflow-hidden hover:shadow-xl hover:bg-white/80 transition-all flex flex-col justify-between group"
                      >
                        <div className="p-6">
                          <div className="flex justify-between items-start mb-3 gap-2">
                            <h4 className="text-lg font-bold text-gray-800 group-hover:text-teal-700 transition-colors leading-snug">
                              {item.name}
                            </h4>
                            <div className="text-right flex-shrink-0">
                              <span className="inline-block bg-gradient-to-r from-teal-700 to-emerald-600 text-white font-bold px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap">
                                {item.price}
                              </span>
                              {item.subtitle && (
                                <span className="block text-[11px] text-gray-500 font-medium mt-0.5">
                                  {item.subtitle}
                                </span>
                              )}
                            </div>
                          </div>

                          <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                            {item.description}
                          </p>
                        </div>

                        <div className="px-6 pb-6 pt-0">
                          <button
                            onClick={() => openModal(item.name, item.description, item.imageKey, item.duration, item.dressCode, item.benefits)}
                            className="w-full py-2.5 px-4 bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center space-x-2 border border-teal-200/60 shadow-sm"
                          >
                            <span>Ver detalles del masaje</span>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Pie de página oficial */}
            <div className="mt-20 text-center space-y-4">
              <div className="inline-flex items-center justify-center px-6 py-2 rounded-full bg-white/80 shadow-md border border-teal-200 space-x-2">
                <span className="text-teal-800 font-serif italic text-lg font-semibold">Tu cuerpo también merece cuidado ♡</span>
              </div>
              <p className="text-sm text-gray-600 font-medium">
                Consultá por turnos, promociones y tratamientos personalizados.
              </p>
              <p className="text-xs text-gray-500 font-semibold tracking-widest uppercase">
                • CUIDA TU CUERPO • RELAJÁ TU MENTE • REALZÁ TU BELLEZA •
              </p>
            </div>
          </div>
        </motion.section>

        <EsteticaModal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={modalContent.title}
          content={modalContent.description}
          imageUrl={modalContent.imageUrl}
          duration={modalContent.duration}
          dressCode={modalContent.dressCode}
          benefits={modalContent.benefits}
          DurationIcon={DurationIcon}
          DressCodeIcon={DressCodeIcon}
        />
      </div>
    </div>
  );
}

export default EsteticaMasajes;